module.exports = __webpack_public_path__ + "static/media/cursor.cd3f0487.svg";